import { FullPageError } from '~/components/Errors'

export default function DemoDataRequiredFullPageError() {
  return (
    <FullPageError
      customFriendlyMessage={
        "Please enable demo data using the Demo button in the bottom left. If you don't see the Demo button, ask SWE to enable the demo controls feature flag for you."
      }
    />
  )
}
